import { isAxiosError } from 'axios';

export const resolveErrorMessage = (
  error: unknown,
  fallback = 'We could not process your request. Please try again.',
): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data as unknown;

    if (typeof data === 'string') {
      return data;
    }

    if (
      data &&
      typeof data === 'object' &&
      'detail' in data &&
      typeof (data as { detail: unknown }).detail === 'string'
    ) {
      return (data as { detail: string }).detail;
    }

    if (
      data &&
      typeof data === 'object' &&
      'errors' in data &&
      Array.isArray((data as { errors: Array<{ detail?: string }> }).errors)
    ) {
      const firstDetail = (
        data as { errors: Array<{ detail?: string }> }
      ).errors.find((item) => item.detail)?.detail;
      if (firstDetail) {
        return firstDetail;
      }
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};
